/** 退场：劳务公司 labor_admin 是否配置了薪酬统计模块 */

function pageCodeOf(item) {
  if (!item) return ''
  return String(
    item.pageCode || item.name || item.pageName || item.path || ''
  ).trim()
}

function pageTreeHasSalaryPayment(pages) {
  if (!Array.isArray(pages) || !pages.length) return false
  const stack = pages.slice()
  while (stack.length) {
    const item = stack.shift()
    if (!item) continue
    const code = pageCodeOf(item)
    const path = String(item.path || '')
    if (
      code === 'salaryPayment' ||
      code === 'salaryPay' ||
      path.indexOf('/workbench/salaryPayment') !== -1 ||
      String(item.pageName || '').indexOf('薪酬统计') !== -1
    ) {
      return true
    }
    if (item.children && item.children.length) {
      stack.push.apply(stack, item.children)
    }
  }
  return false
}

/** 缺省回溯月数（进场日为空时） */
const DEFAULT_LOOKBACK_MONTHS = 24

/** 生成 yyyy-MM 列表（含起止月）；起日为空时回溯 DEFAULT_LOOKBACK_MONTHS 个月 */
export function listYearMonths(fromDate, toDate) {
  let start = parseYearMonth(fromDate)
  const end = parseYearMonth(toDate || new Date())
  if (!end) return []
  if (!start) {
    const d = new Date(end.y, end.m - 1, 1)
    d.setMonth(d.getMonth() - (DEFAULT_LOOKBACK_MONTHS - 1))
    start = { y: d.getFullYear(), m: d.getMonth() + 1 }
  }
  const months = []
  let y = start.y
  let m = start.m
  let guard = 0
  while (y < end.y || (y === end.y && m <= end.m)) {
    months.push(y + '-' + (m < 10 ? '0' + m : '' + m))
    m += 1
    if (m > 12) {
      m = 1
      y += 1
    }
    guard += 1
    if (guard > 120) break
  }
  return months
}

function parseYearMonth(value) {
  if (!value) return null
  if (value instanceof Date && !isNaN(value.getTime())) {
    return { y: value.getFullYear(), m: value.getMonth() + 1 }
  }
  const text = String(value).trim().replace(/\//g, '-')
  const match = text.match(/^(\d{4})-(\d{1,2})/)
  if (!match) return null
  const y = Number(match[1])
  const m = Number(match[2])
  if (!y || !m || m < 1 || m > 12) return null
  return { y, m }
}

export function isPayslipExitBlocked(item) {
  if (!item) return false
  const status = String(item.payStatus || item.pay_status || '').trim()
  if (
    status.indexOf('未结算') !== -1 ||
    status.indexOf('待确认') !== -1 ||
    status.indexOf('未确认') !== -1 ||
    status.indexOf('被拒绝') !== -1
  ) {
    return true
  }
  const isPay = item.isPay
  const settled =
    isPay === '已结算' ||
    isPay === true ||
    isPay === 1 ||
    isPay === '1'
  const conf = String(item.isConf == null ? '' : item.isConf).trim()
  // 已确认=1；2待确认、0拒绝、空且未结算均视为未完成
  const confirmed = conf === '1'
  const clock = String(
    item.isConfClock == null ? item.is_conf_clock || '' : item.isConfClock
  ).trim()
  const clockOk = clock !== '0'
  return !settled || !confirmed || !clockOk
}

export { pageTreeHasSalaryPayment }

/** 当前登录用户菜单是否含薪酬统计 */
export function currentUserHasSalaryPayment(store) {
  if (!store || !store.getters) return false
  const pages =
    store.getters['user/pages'] ||
    store.getters['user/menuPages'] ||
    (store.state && store.state.user && store.state.user.pages) ||
    []
  return pageTreeHasSalaryPayment(pages)
}

/**
 * 判断劳务公司 labor_admin 是否开通薪酬统计。
 * 查不到机构时默认 true（走完整薪酬/承诺书流程，避免误跳过）。
 */
export async function resolveLaborSalaryExitGate(store, laborTeamUid) {
  const uid = String(laborTeamUid || '').trim()
  if (!uid || !store || !store.dispatch) return true
  try {
    return !!(await store.dispatch('role/laborAdminHasSalaryPayment', uid))
  } catch (e) {
    return true
  }
}

/**
 * 批量退场是否需要校验未结算/未确认工资条：
 * 仅按该劳务公司 labor_admin 是否开通薪酬统计判断（标段代操作同样按劳务公司权限）。
 */
export async function needBatchPayslipExitCheck(store, laborTeamUid) {
  return resolveLaborSalaryExitGate(store, laborTeamUid)
}
